import React from "react";

import { TradeLogGradientBadge } from "@/components/trade-log-gradient-badge";
import { cn } from "@/lib/utils";

type UniversityCourseStatusBadgeProps = {
  tone: "completed" | "progress";
  children: React.ReactNode;
  className?: string;
};

export function UniversityCourseStatusBadge({
  tone,
  children,
  className,
}: UniversityCourseStatusBadgeProps): React.ReactElement {
  return (
    <TradeLogGradientBadge
      tone={tone === "completed" ? "positive" : "warning"}
      className={cn("shrink-0", className)}
    >
      {children}
    </TradeLogGradientBadge>
  );
}
